//import { tokenRequest } from "../configs/authConfig";
//import { msalInstance } from "../configs/msalSetup.config";
import { API_BASE_URL  } from "../constants/env";
//import axios, { AxiosResponse, AxiosError } from 'axios';
import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from 'axios';
// Type definitions
interface ApiError {
    message: string;
    status: number;
    details?: any;
}
type ExtraFields = Record<string, string | number | boolean>;
function mapToModel<T>(arr: any[], ctor: new (data: any) => T): T[] {
    return arr.map(item => new ctor(item));
}

// Base URL logic updated for Vite
const baseUrl = `${API_BASE_URL }/api`

const apiClient = axios.create({
    baseURL: baseUrl,
    timeout: 600000, // 1 minute timeout
});

// Request interceptor for adding auth token
apiClient.interceptors.request.use(
    async (config) => {
        // try {
        //     // const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
        //     // config.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
        //     // console.log(`Bearer ${tokenResponse.accessToken}`)
        // } catch (error) {
        //     console.error('Token acquisition failed:', error);
        // }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);


// =====uploadBlob start here
const uploadBlob = async <T = any>(
    url: string,
    file: File | Blob,
    fieldName = "File",
    extraFields?: ExtraFields
): Promise<T> => {
    const fd = new FormData();
    const filename = file instanceof File ? file.name : "upload.bin";
    fd.append(fieldName, file, filename);

    if (extraFields) {
        for (const [k, v] of Object.entries(extraFields)) {
            fd.append(k, String(v));
        }
    }

    const res = await apiClient.post<T>(url, fd, {
        headers: {
        },
    });
    return res.data as any;
};


const uploadFormData = async <T = any>(url: string, formData: FormData): Promise<T> => {
    const res = await apiClient.post<T>(url, formData, {
        headers: {
        },
    });
    return res.data as any;
};
// =================blob end here==================


// Response interceptor for error handling
apiClient.interceptors.response.use(
    (response: AxiosResponse) => {
        return response;
    },
    (error: AxiosError) => {
        const apiError: ApiError = {
            message: error.message || 'An error occurred',
            status: error.response?.status || 500,
            details: error.response?.data
        };

        console.error(`API Error [${apiError.status}]:`, apiError.message);
        return Promise.reject(apiError);
    }
);

const getOptions = async (): Promise<{ headers: any }> => {
    // Uncomment when MSAL is ready
    // const tokenResponse = await msalInstance.acquireTokenSilent(tokenRequest);
    const headers = {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': 'true'
    };
    return {
        headers
    };
};

// Generic HTTP method
const get = async function <T>(url: string): Promise<T> {
    try {
        const options = await getOptions();
        const response = await apiClient.get<T>(url, options);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const post = async <T,>(url: string, body: any): Promise<T> => {
    try {
        const options = await getOptions();
        const response = await apiClient.post<T>(url, body, options);
        return response.data;
    } catch (error) {
        throw error;
    }
};


const put = async <T,>(url: string, body: any): Promise<T> => {
    try {
        const options = await getOptions();
        const response = await apiClient.put<T>(url, body, options);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const del = async <T,>(url: string): Promise<T> => {
    try {
        const options = await getOptions();
        const response = await apiClient.delete<T>(url, options);
        return response.data;
    } catch (error) {
        throw error;
    }
};

const getBlob = async (url: string, config?: AxiosRequestConfig): Promise<Blob> => {
    const response = await apiClient.get(url, { responseType: "blob", ...(config || {}) });
    return response.data as Blob;
};

// Export only generic HTTP methods
export default {
    get,
    post,
    put,
    delete: del,
    mapToModel,
    uploadBlob,
    uploadFormData,
    getBlob
};

// Also export as named exports for flexibility
export {
    get,
    post,
    put,
    del as delete,
    mapToModel,
    uploadBlob,
    uploadFormData,
    getBlob
};

// Export types for consumers
export type { ApiError };





